import component from './PhArrowBendRightUp.vue_vue_type_script_lang.vue.js';
export { default } from './PhArrowBendRightUp.vue_vue_type_script_lang.vue.js';
import { render } from './PhArrowBendRightUp.vue_vue_type_template_id_fc22849a_lang.vue.js';

component.render = render;
